var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { flowsApi } from 'apis/flows';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
/** A hook that handles renaming a flow. */
export const useUpdateFlow = () => {
    const dispatch = useAppDispatch();
    const updateFlow = useCallback(({ flow, id: flowId }) => __awaiter(void 0, void 0, void 0, function* () {
        const { data: currentFlow } = yield dispatch(flowsApi.endpoints.readFlow.initiate({ id: flowId })).unwrap();
        const payload = {
            flow: Object.assign(Object.assign({}, currentFlow), flow),
            id: flowId,
        };
        return dispatch(flowsApi.endpoints.updateFlow.initiate(payload));
    }), [dispatch]);
    return updateFlow;
};
